<template lang="pug">
  div
    .row
      .col-xl-6
        .heading--section {{ controls.currentTab === 'myNews' ? 'My Stock News' : 'Latest Stock News'  }}
        
        .pad_t--5.text--size_13.text--color_grey
          span(v-if="controls.currentTab === 'myNews'") Last updated: {{ myNews_date_time }}
          span(v-else) Last updated: {{ news_date_time }}

      .col-xl-6
        .align__right.align__left-lg.mt-2
          b-button-group
            b-button(:class="{ active: controls.currentTab === 'generalNews' }", @click="CHANGE_TAB('generalNews')", size="sm"): small.text-uppercase Latest news
            b-button(:class="{ active: controls.currentTab === 'myNews' }", @click="CHANGE_TAB('myNews')", size="sm"): small.text-uppercase My news

    .mt-3
      //---------------------------------
      //- TODO: Needs to find a better way of doing small text
      //- Suggestion: Do a font size helper, then use that
      //- Temporary dumb solution first
      //---------------------------------

      Loading(:isLoading="isDataLoading", type="bar")

        //- ---------------------------------
        //- MY NEWS TAB
        //- ---------------------------------
        template(v-if="controls.currentTab === 'myNews'")
          DataTable(
            :records="myNews.records", 
            :headers="headersMyNews", 
            :displaySearch="false", 
            :displayItemsPerPage="false",
          )
            template(v-slot:slot-for-publishedTimeString="item")
              small {{ item.record.attributes.date }} <br class="hidden_lg" />{{ item.record.attributes.time }}
            template(v-slot:slot-for-title="item")
              template(v-if="item.record.attributes.content")
                a.link__primary_light(href="#", @click.prevent="CLICK_ON_SINGLE_NEWS({ content: item.record.attributes.content, title: item.record.attributes.title, date: item.record.attributes.date, time: item.record.attributes.time, author: item.record.attributes.author, provider: item.record.attributes.provider, link: item.record.attributes.link, news_item: item, relatedCounters: item.record.relationship.counters.data })") 
                  | {{ item.record.attributes.title }}
                br
                small.text--color_grey [{{ item.record.attributes.provider }}]

              template(v-else)
                | {{ item.record.attributes.title }}
                br
                small.text--color_grey [{{ item.record.attributes.provider }}]


        //- ---------------------------------
        //- GENERAL NEWS TAB
        //- ---------------------------------
        template(v-if="controls.currentTab === 'generalNews'")
          DataTable(
            :records="generalNews.records", 
            :headers="headersGeneralNews", 
            :displaySearch="false", 
            :displayItemsPerPage="false",
          )
            template(v-slot:slot-for-publishedTimeString="item")
              small {{ item.record.attributes.date }} <br class="hidden_lg" />{{ item.record.attributes.time }}
            template(v-slot:slot-for-title="item")
              template(v-if="item.record.attributes.content")
                a.link__primary_light(href="#", @click.prevent="CLICK_ON_SINGLE_NEWS({ content: item.record.attributes.content, title: item.record.attributes.title, date: item.record.attributes.date, time: item.record.attributes.time, author: item.record.attributes.author, provider: item.record.attributes.provider, link: item.record.attributes.link, news_item: item, relatedCounters: item.record.relationship.counters.data })") 
                  | {{ item.record.attributes.title }}
                  br
                  small.text--color_grey [{{ item.record.attributes.provider }}]
                  
              template(v-else)
                | {{ item.record.attributes.title }}
                br
                small.text--color_grey [{{ item.record.attributes.provider }}]

</template>


<script>
import * as moment from 'moment';

import requestHandlers from '../mixins/requestHandlers';

import DataTable from './DataTable';
import Loading from './Loading';

export default {
  mixins: [requestHandlers],

  components: {
    DataTable,
    Loading
  },

  data() {
    return {
      controls: {
        currentTab: 'generalNews', // 'myNews' / 'generalNews'
      },
      generalNews: {
        records: [],
        meta: {},
      },
      myNews: {
        records: [],
        meta: {},
      },

      headersMyNews: [
        {
          id: 'publishedTimeString',
          text: 'Date & Time',
          type: 'custom_slot',
          colWidth: 25,
        },
        {
          id: 'title',
          text: 'News title',
          type: 'custom_slot',
          colWidth: 75,
        },
      ],
      headersGeneralNews: [
        {
          id: 'publishedTimeString',
          text: 'Date & Time',
          type: 'custom_slot',
          colWidth: 25,
        },
        {
          id: 'title',
          text: 'News title',
          type: 'custom_slot',
          colWidth: 75,
        },
      ],
    }
  },

  computed: {
    myNews_date_time() {
      let _dateTime = '';

      if(!this.myNews.meta.lastUpdatedTime || this.myNews.meta.lastUpdatedDate) {
        _dateTime = moment().format('hh:mm A, YYYY-MM-DD');
      } else {
        _dateTime = `${this.myNews.meta.lastUpdatedTime }, ${this.myNews.meta.lastUpdatedDate}`;
      }

      return _dateTime;
    },

    news_date_time() {
      let _dateTime = '';

      if(!this.generalNews.meta.lastUpdatedDate || !this.generalNews.meta.lastUpdatedTime) {
        _dateTime = moment().format('hh:mm A, YYYY-MM-DD');
      } else {
        _dateTime = `${this.generalNews.meta.lastUpdatedTime}, ${this.generalNews.meta.lastUpdatedDate}`;
      }
      return _dateTime;
    },
  },

  methods: {
    CHANGE_TAB(tab) {
      this.controls.currentTab = tab;
    },
    CLICK_ON_SINGLE_NEWS(payload) {
      this.$emit('clickOnStockNews', payload);
    },


    FETCH_RECORDS() {
      this.REQUEST_INIT();
      Promise.all([
        this.$axios.get('/News/Latest'),
        this.$axios.get('/News/MyLatest')
      ])
      .then(response => {
        let [ responseGeneral, responseMy ] = response;

        if(responseGeneral.status === 200 && responseMy.status === 200) {
          this.generalNews.records = responseGeneral.data.data;
          this.generalNews.meta = responseGeneral.data.meta;

          this.myNews.records = responseMy.data.data;
          this.myNews.meta = responseMy.data.meta;
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    }
  },


  created() {
    this.FETCH_RECORDS();
  },
}
	
</script>



<style lang="scss">
	
</style>